import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { NEWS_BODY_MAX, NEWS_TITLE_MAX } from '@crm/shared'
import { createNewsPost } from '../../shared/api/news.api'

export function NewsComposer() {
  const qc = useQueryClient()
  const [title, setTitle] = useState('')
  const [body, setBody] = useState('')

  const mut = useMutation({
    mutationFn: () => createNewsPost({ title: title.trim(), body: body.trim() }),
    onSuccess: () => {
      setTitle('')
      setBody('')
      void qc.invalidateQueries({ queryKey: ['news'] })
    },
  })

  const titleOk = title.trim().length > 0 && title.trim().length <= NEWS_TITLE_MAX
  const bodyOk = body.trim().length > 0 && body.trim().length <= NEWS_BODY_MAX
  const canSubmit = titleOk && bodyOk && !mut.isPending

  return (
    <section className="rounded-xl border border-gray-200 bg-white p-4">
      <h2 className="text-sm font-semibold text-gray-900 mb-3">Опубликовать новость</h2>
      <div className="space-y-2">
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength={NEWS_TITLE_MAX}
          placeholder="Заголовок"
          className="w-full text-sm rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-200"
        />
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          maxLength={NEWS_BODY_MAX}
          rows={5}
          placeholder="Текст новости. Поддерживаются переносы строк."
          className="w-full text-sm rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-200 resize-y"
        />
        {mut.isError && (
          <p className="text-xs text-red-600">
            Не удалось опубликовать новость. Попробуйте ещё раз.
          </p>
        )}
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-400">
            {body.length} / {NEWS_BODY_MAX}
          </span>
          <button
            onClick={() => mut.mutate()}
            disabled={!canSubmit}
            className="text-sm px-4 py-2 rounded-md bg-brand-600 text-white hover:bg-brand-700 disabled:opacity-50 transition-colors"
          >
            {mut.isPending ? 'Публикуем…' : 'Опубликовать'}
          </button>
        </div>
      </div>
    </section>
  )
}
